import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/fram2.png")